const StateMaster = {
  states: [
      {
        stateCode: "01",
        stateName: "JOHOR",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "02",
        stateName: "KEDAH",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "03",
        stateName: "KELANTAN",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "04",
        stateName: "MELAKA",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "05",
        stateName: "NEGERI SEMBILAN",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "06",
        stateName: "PAHANG",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "07",
        stateName: "PULAU PINANG",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "08",
        stateName: "PERAK",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "09",
        stateName: "PERLIS",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "10",
        stateName: "SELANGOR",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "11",
        stateName: "TERENGGANU",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "12",
        stateName: "SABAH",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "13",
        stateName: "SARAWAK",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "14",
        stateName: "WP KUALA LUMPUR",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "15",
        stateName: "WP LABUAN",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
      {
        stateCode: "16",
        stateName: "WP PUTRAJAYA",
        active: true,
        createdOn: 1626841560000,
        lastModifiedOn: null,
      },
  ]
}

export default StateMaster